import IAmount from "./IAmount";
import OrderType from "@/module/main/dto/OrderTypeEnum";
import IOrderBase from "@/module/main/dto/IOrderBase";
import IBrokeredOrder from "@/module/main/dto/IBrokeredOrder";
import IOrderFinancing from "@/module/main/dto/IOrderFinancing";
import IOperatingLeaseOrder from "@/module/main/dto/IOperatingLeaseOrder";
import ICarLoanOrder from "@/module/main/dto/ICarLoanOrder";
import IStandardOrder from "@/module/main/dto/IStandardOrder";

export default class OrderBase implements IOrderBase
{
    public readonly brokered?: IBrokeredOrder;
    public readonly number: string | undefined;
    public readonly preferredDownPayment: IAmount | undefined;
    public readonly totalPrice: IAmount | undefined;
    public readonly type: OrderType;
    public readonly variableSymbol: string | undefined;
    public readonly specificSymbol?: string;
    public readonly financings: [IOrderFinancing];
    public readonly operatingLease: IOperatingLeaseOrder | undefined;
    public readonly carLoan?: ICarLoanOrder;
    public readonly standard?: IStandardOrder;

    constructor(props: IOrderBase)
    {
        this.brokered = props.brokered;
        this.number = props.number;
        this.preferredDownPayment = props.preferredDownPayment;
        this.totalPrice = props.totalPrice;
        this.type = props.type;
        this.variableSymbol = props.variableSymbol;
        this.specificSymbol = props.specificSymbol;
        this.financings = props.financings;
        this.operatingLease = props.operatingLease;
        this.carLoan = props.carLoan;
        this.standard = props.standard;
    }
}
